import React from 'react'
import Fragment from '../common/fragment'

function FragmentDX(props) {
  return (
    <Fragment pos="xxxx" {...props}>
      <p>
zzzzzzzzzzzzzzzzzZzZzZzzzzzzzzzzzzzzzzzzzzzzzzzzz
zzzzzzzzzzzzz
      </p>
    </Fragment>
  )
}


export default FragmentDX
